import { render } from "./StartMessage.vue?vue&type=template&id=32c0c4ef"
import script from "./StartMessage.vue?vue&type=script&lang=js"
export * from "./StartMessage.vue?vue&type=script&lang=js"

import "./StartMessage.vue?vue&type=style&index=0&id=32c0c4ef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__